{
  "longPressMessage": "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
}
